import { default as advancedFilters } from './advancedFilters.json';
import { default as adminMessages } from './adminMessages.json';
import { default as agentBots } from './agentBots.json';
import { default as agentMgmt } from './agentMgmt.json';
import { default as attributesMgmt } from './attributesMgmt.json';
import { default as auditLogs } from './auditLogs.json';
import { default as automation } from './automation.json';
import { default as bridgeChannels } from './bridgeChannels.json';
import { default as bulkActions } from './bulkActions.json';
import { default as campaign } from './campaign.json';
import { default as cannedMgmt } from './cannedMgmt.json';
import { default as components } from './components.json';
import { default as chatlist } from './chatlist.json';
import { default as contact } from './contact.json';
import { default as contactFilters } from './contactFilters.json';
import { default as conversation } from './conversation.json';
import { default as csatMgmt } from './csatMgmt.json';
import { default as customRole } from './customRole.json';
import { default as datePicker } from './datePicker.json';
import { default as emoji } from './emoji.json';
import { default as general } from './general.json';
import { default as generalSettings } from './generalSettings.json';
import { default as durationInput } from './durationInput.json';
import { default as helpCenter } from './helpCenter.json';
import { default as importData } from './import.json';
import { default as inbox } from './inbox.json';
import { default as inboxMgmt } from './inboxMgmt.json';
import { default as integrationApps } from './integrationApps.json';
import { default as integrations } from './integrations.json';
import { default as kanban } from './kanban.json';
import { default as labelsMgmt } from './labelsMgmt.json';
import login from './login.json';
import macros from './macros.json';
import report from './report.json';
import resetPassword from './resetPassword.json';
import search from './search.json';
import setNewPassword from './setNewPassword.json';
import settings from './settings.json';
import signup from './signup.json';
import sla from './sla.json';
import teamsSettings from './teamsSettings.json';
import whatsappTemplates from './whatsappTemplates.json';
import time from './time.json';
import erp from './erp.json';
import serviceDesk from './serviceDesk.json';
import sessionLimit from './sessionLimit.json';
import duplicateTab from './duplicateTab.json';

export default {
  ...advancedFilters,
  ...adminMessages,
  ...agentBots,
  ...agentMgmt,
  ...attributesMgmt,
  ...auditLogs,
  ...automation,
  ...bridgeChannels,
  ...bulkActions,
  ...campaign,
  ...cannedMgmt,
  ...components,
  ...chatlist,
  ...contact,
  ...contactFilters,
  ...conversation,
  ...csatMgmt,
  ...customRole,
  ...datePicker,
  ...emoji,
  ...general,
  ...generalSettings,
  ...durationInput,
  ...helpCenter,
  ...importData,
  ...inbox,
  ...inboxMgmt,
  ...integrationApps,
  ...integrations,
  ...kanban,
  ...labelsMgmt,
  ...login,
  ...macros,
  ...report,
  ...resetPassword,
  ...search,
  ...setNewPassword,
  ...settings,
  ...signup,
  ...sla,
  ...teamsSettings,
  ...whatsappTemplates,
  ...time,
  ...erp,
  ...serviceDesk,
  ...sessionLimit,
  ...duplicateTab,
};
